import axios from 'axios';
import { getAuth } from 'firebase/auth';

const apiUrl = import.meta.env.VITE_BACKEND_URL_NEW;

const axiosServices = axios.create({ baseURL: apiUrl });

// request interceptor to inject Firebase authentication token
axiosServices.interceptors.request.use(
  async config => {
    const auth = getAuth();
    const user = auth?.currentUser;
    if (user) {
      // const idToken = await user.getIdToken(/* forceRefresh= */ true);
      const idToken = await user.getIdToken();
      config.headers['Authorization'] = `Bearer ${idToken}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const http = axiosServices;
